var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("顧客の移管")]),(_vm.createdStep)?_c('step-contents',{attrs:{"steps":_vm.steps}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }